// Paginated list responses from the API. Older API versions returned a bare
// array; toPage accepts both so the UI works whichever is deployed first.
export interface Page<T> {
  content: T[];
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  last: boolean;
}

export interface PageInfo {
  page: number;
  last: boolean;
  totalElements: number;
}

export const PAGE_SIZE = 20;

export const EMPTY_PAGE_INFO: PageInfo = { page: 0, last: true, totalElements: 0 };

export function toPage<T>(data: T[] | Page<T> | null | undefined): Page<T> {
  if (Array.isArray(data)) {
    return {
      content: data,
      page: 0,
      size: data.length,
      totalElements: data.length,
      totalPages: data.length > 0 ? 1 : 0,
      last: true,
    };
  }
  if (!data) {
    return { content: [], page: 0, size: 0, totalElements: 0, totalPages: 0, last: true };
  }
  return data;
}

export function pageInfoOf<T>(page: Page<T>): PageInfo {
  return { page: page.page, last: page.last, totalElements: page.totalElements };
}

/** Page 0 replaces the list; later pages append, skipping items already shown. */
export function mergePage<T extends { id: number }>(existing: T[], page: Page<T>): T[] {
  if (page.page === 0) return page.content;
  const seen = new Set(existing.map((item) => item.id));
  return [...existing, ...page.content.filter((item) => !seen.has(item.id))];
}

export function withPaging(path: string, page: number, size: number = PAGE_SIZE): string {
  const separator = path.includes("?") ? "&" : "?";
  return `${path}${separator}page=${page}&size=${size}`;
}
